<template>
    <div>
        <header-ton @boxLogin="IsUsersLogin" :actived="4"></header-ton>
        <login-box :showLogin="showLogin" @closeLogin="closeBox" ref="login"></login-box>
        <column-box @setSubject="setBoxSubject" :showColumn="showColumn" :classId="class_id" :columnId="column_id"
            :subjectId="subject_id" @closeColumn="closeBoxColumn" ref="column"></column-box>
        <div class="chapter">
            <div class="c_left">
                <div class="title">考试方向</div>
                <div class="meaus">
                    <div :class="class_id == item.id ? 'li active' : 'li'" @click="getColumn(item.id)"
                        v-for="(item, index) in classData" :key="index">
                        <img :src="item.thumb" width="24" height="24" />
                        {{ item.title }}
                    </div>
                </div>
            </div>
            <div class="c_right" v-loading="loading" element-loading-text="数据加载中">

                <header class="home_header">
                    <div class="context_box">
                        <b>{{ columnName }}</b> <span>{{ subjectName }}</span>
                        <div class="check_box" @click="changeColumn">
                            <div class="el-dropdown">
                                <p class=" el-dropdown-selfdefine  "><i>切换</i><span></span></p>
                            </div>
                        </div>
                    </div>
                </header>

                <div class="sq_conbox">
                    <div class="sq_navs">
                        <div class="sq_nav_title grey">考点速记（ {{ base.pages + '/' + base.total }} ）</div>
                        <div class="sq_nav_desc grey"><i class="el-icon-date"></i>查看报告</div>
                        <div class="sq_nav_desc grey"><i class="el-icon-s-unfold"></i>目录</div>
                    </div>
                    <div class="sq_detail">
                        <div class="sq_li">{{ info.title }}</div>
                        <div class="sq_btn" v-html="info.content1"></div>
                    </div>
                </div>

                <div class="home_footer">
                    <div class="f_li">上一个</div>
                    <div class="f_li">记住了</div>
                    <div class="f_li">再复习</div>
                    <div class="f_li">下一个</div>
                </div>
            </div>
        </div>
        <booter-ton></booter-ton>
    </div>
</template>


<script>
import HeaderTon from "@/components/HeaderTon";
import BooterTon from "@/components/BooterTon";
import LoginBox from "@/components/LoginBox";
import ColumnBox from "@/components/ColumnBox";

export default {
    components: {
        HeaderTon,
        BooterTon,
        LoginBox,
        ColumnBox,
    },
    data() {
        return {
            loading: true,
            subject_id: 0,
            selected: 0,
            class_id: 1,
            column_id: 0,
            columnName: '',
            subjectName: '',
            showLogin: false,
            showColumn: false,
            classData: [],
            columnData: [],
            subjectData: [],
            squareData: [],
            putData: [],
            teacherData: [],
            catData: [],
            id: 0,
            info: [],
            base: [],
        };
    },
    mounted() {
        var that = this;
        var query = that.$route.query;
        if (query.id) {
            that.id = query.id;
        }
        let class_id = sessionStorage.getItem("access-class_id");
        let column_id = sessionStorage.getItem("access-column_id");
        let subject_id = sessionStorage.getItem("access-subject_id");
        console.log(class_id);
        if (class_id == '' || class_id == null) {
            class_id = 1;
        }
        that.class_id = Number(class_id);
        if (column_id == '' || column_id == null) {
            column_id = 5;
        }
        if (subject_id == '' || subject_id == null) {
            subject_id = 8;
        }
        that.subject_id = Number(subject_id);
        that.column_id = Number(column_id);
        this.getSquareData();
        this.getList();
    },
    methods: {

        setBoxSubject(e) {
            console.log(e);
            this.page = 1;
            this.column_id = e.column_id;
            this.subject_id = e.subject_id;
            this.showColumn = false;
            this.getSquareData();
            this.getChapterList();
        },

        getColumn(e) {
            console.log(e);
            this.class_id = e;
            this.$refs.columnId = e;
            this.showColumn = true;
            sessionStorage.setItem("access-class_id", e);
        },

        //获取一级分类
        getList() {
            let that = this;
            let formData = {};
            formData.column_id = that.column_id;
            formData.limit = that.limit;
            that.axios.post("/getColumnCate", formData).then((res) => {
                if (res) {
                    that.classData = res.data;
                    that.getChapterList();
                }
            });
        },

        selectChange(e) {
            console.log(e);
            if (this.selected == e) {
                this.selected = 0;
            } else {
                this.selected = e;
            }
        },

        changeColumn() {
            this.showColumn = true;
            this.$refs.column.getColumnList();
        },

        goDetail(ids) {
            this.$router.push({
                path: "/web/square_detail",
                query: {
                    id: ids,
                },
            });
        },

        //判断是否登录
        IsUsersLogin() {
            let token = sessionStorage.getItem("access-token");
            console.log(token);
            if (token) {
                return true;
            } else {
                this.showLogin = true;
                this.$refs.login.getMiQrCode();
                return false;
            }
        },

        closeBox(e) {
            this.showLogin = false;
        },

        closeBoxColumn(e) {
            console.log(e);
            this.showColumn = false;
        },

        //获取章节类别
        getChapterList() {
            let that = this;
            let formData = {};
            that.loading = true;
            formData.id = that.id;
            formData.points_id = 0;
            that.axios.post("/getPointsDetail", formData).then((res) => {
                if (res) {
                    that.info = res.data.info;
                    that.base = res.data.base;
                    that.loading = false;
                }
            });
        },

        //加载更多
        getLoadingMore() {
            this.page = this.page + 1;
            this.getChapterList();
        },

        //获取章节类别
        getSquareData() {
            let that = this;
            let formData = {};
            that.loading = true;
            formData.column_id = that.column_id;
            formData.subject_id = that.subject_id;
            that.axios.post("/getSquareData", formData).then((res) => {
                if (res) {
                    console.log(res.data.cate);
                    that.columnName = res.data.column.title;
                    that.subjectName = res.data.subject.title;
                    that.teacherData = res.data.teacher;
                    that.catData = res.data.cate;
                    that.putData = res.data.puts;
                }
            });
        },

    },
};
</script>

<style scoped>
.chapter {
    width: 1200px;
    margin: 90px auto 20px auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.chapter .c_left {
    width: 21%;
    background: #fff;
    padding: 20px 0;
}

.chapter .c_left .title {
    height: 45px;
    line-height: 45px;
    text-align: center;
    font-weight: bold;
    font-size: 18px;
}

.chapter .meaus {
    display: flex;
    flex-direction: column;
}

.chapter .meaus .li {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    height: 60px;
    align-items: center;
    padding: 0 20px;
    cursor: pointer;
    border-left: 2px solid #ffffff;
}

.chapter .meaus .active {
    background: linear-gradient(90deg, #ffffff 0%, #f3f6ff 100%);
    color: #4171f9;
    border-left: 2px solid #4171f9;
}

.chapter .meaus .li:hover {
    background: linear-gradient(90deg, #ffffff 0%, #f3f6ff 100%);
    color: #4171f9;
    border-left: 2px solid #4171f9;
}

.chapter .meaus .li img {
    margin-right: 10px;
}

.chapter .c_right {
    width: 78%;
}

.sq_conbox {
    display: flow-root;
    min-height: 500px;
    background: #fff;
    margin-top: 10px;
}

.sq_conbox .sq_navs {
    background: #fff;
    margin: 10px 0 0 0;
    padding: 0px 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #f5f5f5;
}

.sq_conbox .sq_navs .sq_nav_title {
    width: 80%;
}

.sq_conbox .sq_navs .sq_nav_desc {
    width: 82px;
    margin-right: 5px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
}

.sq_conbox .sq_navs .sq_nav_desc i {
    margin-right: 3px;
}

.sq_conbox .sq_navs .red {
    color: #f82727;
}

.sq_conbox .sq_navs .grey {
    color: #0f0f0f;
}

.sq_conbox .sq_detail {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: #fff;
    font-size: 14px;
}

.sq_conbox .sq_detail .sq_li {
    border-left: 4px solid #FF5000;
    margin: 15px 0;
    font-weight: bold;
    padding-left: 15px;
}


.sq_conbox .sq_detail .sq_btn {
    padding: 0 15px;
    line-height: 32px;
}


.home_header {
    height: 70px;
    width: 100%;
    background: #fff;
    padding: 0 20px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.home_header .context_box {
    display: flex;
    align-items: center;
    justify-content: center;
}

.home_header .context_box>:not(span):not(p) {
    padding-right: 20px;
}

.home_header .context_box>b {
    font-size: 26px;
    line-height: 65px;
    height: 70px;
}

.home_header .context_box>span {
    font-size: 18px;
    line-height: 18px;
    color: #666;
    padding-right: 10px;
}

.home_header .context_box>.check_box {
    position: relative;
}

.home_header .context_box>:not(span):not(p) {
    padding-right: 20px;
}

.el-dropdown {
    display: inline-block;
    position: relative;
    color: #606266;
    font-size: 14px;
}

.home_header .context_box>.check_box p {
    color: #fff;
    font-size: 14px;
    background: #4171f9;
    border-radius: 24px;
    line-height: 36px;
    padding: 0 12px;
    line-height: 28px;
    display: flex;
    align-items: center;
    font-style: normal;
    cursor: pointer;
}

.home_header .context_box>.check_box p>i {
    font-style: normal;
    margin-right: 5px;
}

.home_header .context_box>.check_box p>span {
    display: inline-block;
    width: 15px;
    height: 12px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAyCAYAAABcfPsmAAADm0lEQVRIie1WXWgUVxT+Tu6d3czEpEqqYjChjS8aQYUI+iCJCCKoRQsVoQ8VfLA+lIIovgR9FFFB+yAooiK+iaKBIIWi+EMR0ZY2TbAvWxHxIUlht+zGnd3ZmSMn3llnk9nNbpPSFz843N255373/Hz3zmC+QcyMVCqFjo4OjIyMwLZtZLNZ9PT0TI0TExMoFov9ra2tjuM4jzo7OyfFj4imQmlqakImk4HjOOjt7UVTXICyiWVZUEotYOazjuM8yOfzdwuFwvV0Ot2pta6aV+yMUkoiW+F53nki2sbMw5ZljU9OTn6Zy+W6bdveT0S/ysbTERuhbdt9Y2NjQ9lsdpvWeoiIthPRF1rrS0qptZ7n3QWwI27tDMIgCGT3wWQyuZKIzgHYA+ANAFcpdUApNeB53lJmvs3M38cSSoGVUpL+GWa+XCqVFiYSiYNa60PM7IbOvu+jvb39RFdX117P83wAPwC4wMx2BWEul/sslUrdsSzrMICXAPqVUhdloyAIyiaEiUQCbW1tN3zf3wTgRRAE37a0tAwqpT4vEwZBcCufz+8wUhgE8EgKHkojUg64rgvP8+TvLwB+FD+t9VYAN8tdJqK/lFLitQFAUbRVKBRkqpWIFpUloTXS6XQ6k8lkk8mkPJpiZuanAF5HmyKFHwjLEInsJIBXUWPmk5L6tKYOGI4KHZY7HtHXKjM+NGM/M6/CTJTXVpf8e5TMuDncK/IsFrMRhvi0Tr8KwrBwblhDZg6j+TsadWTenbY2NsJuY+IUdvhGZF6erTDpd8dGaJowTkR5AHuZuc/MLzfjnsiajcz8wPxeBiDPzOMVhHKXEdFoqVT62nXdfUqpT0zxn8c0Qda0yOj7/vPm5uZrWuvRUBkUdwX9W0htY6+vKngM4BmAxbWcGiFsBrAewP2apJJynbaYmf/g9xiWK2v6uijhY24cfXGE9Z6UiqQi9ZyB/7XLdSEklKv/rUmnHvsHwLq4DULC7+TtOZ8RXjFjEcAuczHUMjmav8UyRtp+yginwMzrGtBnVdkcNRfBwbmkTMl7T+rxWwngJwBXARyPTrhbNn4ga0A2UrelAI4BOF3LsV7CFwC+Mu/hI0ZmVQklnYk6tCdfFJZZ981sETZy/tLmIykW0uU/ASxpgLAm/pOzLHZbPv8aOMtDtVJeA2D3fEY4DOB383/U1HO2s7yzFmEAYKshW23Sn1OEMDrcAuBnAJm5EH7ERzQKAO8Ae6gWTMg17TEAAAAASUVORK5CYII=) 0 -18px;
}


.home_footer {
    width: 1200px;
    position: fixed;
    display: flex;
    flex-direction: row;
    bottom: 0;
    left: 0;
    right: 0;
}
</style>